/**
 * @generated SignedSource<<1d1d130a828490ad483edc46c7ab875f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicHeaderTopic$data = {
  readonly breakoutImage: {
    readonly alt: string | null | undefined;
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
  readonly breakoutSponsorImage: {
    readonly alt: string | null | undefined;
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
  readonly description: {
    readonly html: string | null | undefined;
  } | null | undefined;
  readonly mobileImage: {
    readonly alt: string | null | undefined;
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly sponsor: {
    readonly " $fragmentSpreads": FragmentRefs<"sponsorTagSponsor">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "topicHeaderRelatedLinksTopic">;
  readonly " $fragmentType": "topicHeaderTopic";
};
export type topicHeaderTopic$key = {
  readonly " $data"?: topicHeaderTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicHeaderTopic">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicHeaderTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicHeaderRelatedLinksTopic"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "html",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "mobileImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "MOBILE_APP_IMAGE"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "118x118"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "style(filter:{\"style\":\"118x118\"})"
        }
      ],
      "storageKey": "image(type:\"MOBILE_APP_IMAGE\")"
    },
    {
      "alias": "breakoutImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "BREAKOUT"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "2000x792"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "style(filter:{\"style\":\"2000x792\"})"
        }
      ],
      "storageKey": "image(type:\"BREAKOUT\")"
    },
    {
      "alias": "breakoutSponsorImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "BREAKOUT_SPONSOR"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "1560x218"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "style(filter:{\"style\":\"1560x218\"})"
        }
      ],
      "storageKey": "image(type:\"BREAKOUT_SPONSOR\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "sponsorTagSponsor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "b7a764c49eef2766248e7779c6b94cc3";

export default node;
